import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { DatePicker } from "./DateField";

export const MarkPaidDialog = ({ open, onOpenChange, count, max, onSubmit }) => {
  const [paidOn, setPaidOn] = useState(max);
  const [note, setNote] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onSubmit({ paid_on: paidOn, note, file });
    setBusy(false);
    if (ok) onOpenChange(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121824] border-[#1F2A3E] max-w-md" data-testid="raise-paid-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Confirm raise paid</DialogTitle>
          <DialogDescription>{count} worker(s). One proof file covers all selected workers.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="grid gap-4">
          <label className="grid gap-1.5 text-sm"><span className="text-slate-400 text-xs font-medium">Paid on *</span>
            <DatePicker value={paidOn} onChange={setPaidOn} max={max} required clearable={false} testid="raise-paid-date" /></label>
          <label className="grid gap-1.5 text-sm"><span className="text-slate-400 text-xs font-medium">Proof (bank slip or payslip, PDF/JPG/PNG, max 5 MB) *</span>
            <input type="file" required accept="application/pdf,image/png,image/jpeg" className="c-input" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="raise-paid-file" /></label>
          <label className="grid gap-1.5 text-sm"><span className="text-slate-400 text-xs font-medium">Note</span>
            <input className="c-input" maxLength={300} placeholder="e.g. Paid by NEFT with October wages" value={note} onChange={(e) => setNote(e.target.value)} data-testid="raise-paid-note" /></label>
          <DialogFooter><Button type="button" variant="ghost" onClick={() => onOpenChange(false)} data-testid="raise-paid-cancel">Cancel</Button>
            <Button type="submit" disabled={busy || !file || !paidOn} className="bg-[#00E599] text-[#0B1017] hover:bg-[#00E599]/90" data-testid="raise-paid-submit">{busy ? "Saving…" : "Confirm paid"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>);
};
